import PageSection from 'components/containers/page-section';
import MarkdownParser from 'components/rich-text/markdown-parser';
import styles from './content-warning.module.scss';
import ObjectPageSection from '../object-page-section';

//This is the hardcoded version as MVP - we're going to move this to the CMS but I wanted to build this as a cached component
//unfortunately we have issues with cache components and `force dynamic` pages - so I need to do some architecturual investigation ASAP
//But since this has a deadline, I figured it was worth it to get it out in some form before I dive into learning about cached components

const bodyText =
	'The Metropolitan Museum of Art presents over 5,000 years of art from around the world, and our online collection reflects ongoing work conducted over the course of our more than 150-year history. You may encounter objects or images that may be inappropriate for some viewers or information that may be outdated.';
const titleText = 'Content Notice';

const ContentWarning = ({ objectPage = false }: IProps) => {
	if (objectPage) {
		return (
			<ObjectPageSection title={titleText}>
				<p>
					<MarkdownParser>{bodyText}</MarkdownParser>
				</p>
			</ObjectPageSection>
		);
	}

	return (
		<PageSection hasTopDivider={true}>
			<h2 className={styles.title}>
				<MarkdownParser>{titleText}</MarkdownParser>
			</h2>
			<div className={styles.body}>
				<MarkdownParser>{bodyText}</MarkdownParser>
			</div>
		</PageSection>
	);
};

interface IProps {
	objectPage?: boolean;
}

export default ContentWarning;
